import semver from 'semver';

type TMultichoiceDefaultStyles = {
  panelBackground: string;
  panelBorderRadius: number;
  multichoiceMediaPanelBorderRadius: number;
  optionTextColor: string;
  checkboxColor: string;
  mediaPanelWidth: number;
  mediaPanelHeight: number;
  hasSetWidthHeight: boolean;
  includeRadioCheckbox: boolean;
  dropShadow: boolean;
  fixedPanelHeight: boolean;
};

export const multichoiceDefaultStyles: {
  [key: string]: TMultichoiceDefaultStyles;
} = {
  base: {
    panelBackground: '#1A1A2B',
    panelBorderRadius: 5,
    multichoiceMediaPanelBorderRadius: 20,
    optionTextColor: '#fff',
    checkboxColor: '#fff',
    mediaPanelWidth: 320,
    mediaPanelHeight: 360,
    dropShadow: false,
    hasSetWidthHeight: false,
    includeRadioCheckbox: true,
    fixedPanelHeight: false,
  },
  '1.5.0': {
    panelBackground: '#FFFFFF',
    panelBorderRadius: 12,
    multichoiceMediaPanelBorderRadius: 20,
    optionTextColor: '#1A1A2B',
    checkboxColor: '#1A1A2B',
    mediaPanelWidth: 320,
    mediaPanelHeight: 360,
    dropShadow: true,
    hasSetWidthHeight: false,
    includeRadioCheckbox: true,
    fixedPanelHeight: false,
  },
};

export const getDefaultStyles = (blockMetaPackageVersion: string = '') => {
  if (!blockMetaPackageVersion || !semver.valid(blockMetaPackageVersion)) {
    return multichoiceDefaultStyles['base'];
  }

  if (semver.gte(blockMetaPackageVersion, '1.5.0')) {
    return multichoiceDefaultStyles['1.5.0'];
  }
  //
  return multichoiceDefaultStyles['base'];
};
